
import { useRef } from "react";

interface UseChatInputProps {
  inputValue: string;
  setInputValue: (value: string) => void;
  handleSendMessage: () => void;
  isDisabled: boolean;
}

export const useChatInput = ({
  inputValue,
  setInputValue,
  handleSendMessage,
  isDisabled,
}: UseChatInputProps) => {
  const inputRef = useRef<HTMLTextAreaElement>(null);

  const handleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleSendMessage();
    }
  };

  return {
    inputRef,
    handleKeyDown,
  };
};
